// Local translations
export const T = {
  en_GB: {
    continue: "Continue",
    returnIn: (host: string, seconds: number | null) => `Returning you to ${host} in ${seconds} s…`,
    returning: (host: string) => `Returning you to ${host}…`,
    stayHere: "Stay on this page",
  },
  nb_NO: {
    continue: "Fortsett",
    returnIn: (host: string, seconds: number | null) =>
      `Sender deg tilbake til ${host} om ${seconds} s…`,
    returning: (host: string) => `Sender deg tilbake til ${host}…`,
    stayHere: "Bli på denne siden",
  },
} as const;
